(function() {
  'use strict';

  function DeliveryDialogCtrl ($mdDialog, ShippingConfig) {
    var ctrl = this;
    ctrl.isLoading = true;
    ctrl.deliveryOptions = [];
    ShippingConfig.getOptions()
      .then(function (data) {
        ctrl.isLoading = false;
        ctrl.deliveryOptions = data;
      });
    ctrl.close = function () {
      $mdDialog.cancel();
    };
    ctrl.formSubmit = function () {
      var selectedType = _.filter(ctrl.deliveryOptions, function (opt) {
        return opt.servicoEnvio === ctrl.deliveryType;
      })[0];
      $mdDialog.hide({
        code: ctrl.deliveryType,
        displayName: selectedType.nomeExibicao,
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('DeliveryDialogCtrl', DeliveryDialogCtrl);

}());
